import { render, staticRenderFns } from "./OriginallyPublished.vue?vue&type=template&id=649f7cda"
import script from "./OriginallyPublished.vue?vue&type=script&lang=js"
export * from "./OriginallyPublished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports